/**
 * UseImageSizes Dictionary
 */

type Entries<T> = {
  [K in keyof T]: [key: K, value: T[K]];
}[keyof T][];

const imageSizesOrder = ['2xl', 'xl', 'lg', 'lgS', 'mdL', 'md', 'mdS', 'sm', 'base'] as const;

type ImageSizesKey = (typeof imageSizesOrder)[number];
const ImageSizes: Record<ImageSizesKey, string> = {
  base: '',
  sm: '(min-width: 375px)',
  mdS: '(min-width: 640px)',
  md: '(min-width: 834px)',
  mdL: '(min-width: 1024px)',
  lgS: '(min-width: 1280px)',
  lg: '(min-width: 1512px)',
  xl: '(min-width: 1728px)',
  '2xl': '(min-width: 1920px)',
} as const;

/**
 * UseImageSizes Hook
 */

export type UseImageSizesProps = {
  sizes?: Partial<Record<ImageSizesKey, string>>;
};

export const useImageSizes = ({ sizes }: UseImageSizesProps) => {
  if (!sizes) return { parsedSizes: '' };

  const sizesEntries = Object.entries(sizes) as Entries<Required<typeof sizes>>;

  const parsedSizes = sizesEntries
    .sort(([keyA], [keyB]) => imageSizesOrder.indexOf(keyA) - imageSizesOrder.indexOf(keyB))
    .reduce((acc, [key, value]) => acc.concat(`${ImageSizes[key]} ${value},`), '')
    .slice(0, -1);

  return { parsedSizes };
};
